<template>
    <nav
        v-click-outside="(e) => toggleShowMore(false)"
        class="header__top-menu top-menu"
    >
        <ul class="top-menu__list">
            <template v-for="(link, index) in visibleLinks">
                <li
                    v-if="!link.isEcoPage && link.isActive"
                    :key="`${link.slug}_${index}`"
                    class="top-menu__list-item"
                >
                    <n-link
                        class="header__link text-center"
                        prefetch
                        v-bind="getLinkAttr(link.path || link.slug)"
                        :class="{ 'header__link_active': link.slug === 'for-individuals' && $route.path === '/' }"
                        :to="getLink(link)"
                    >
                        {{ link.title }}
                    </n-link>
                </li>
            </template>
            <!-- More -->
            <li
                v-click-outside="() => isShowMoreActive = false"
                class="top-menu__list-item subMenu"
            >
                <button
                    class="cibButton cibButton--empty pointer"
                    @click="(e) => toggleShowMore()"
                >
                    <span>Еще</span>
                    <nuxt-img
                        class="cibButton__chevron"
                        :class="{
                            'opened': isShowMoreActive
                        }"
                        src="icons/arrows/chevron-small.svg"
                        alt=""
                        format="webp"
                    />
                </button>
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <div
                        v-show="isShowMoreActive"
                        class="top-menu__subMenu top-menu-subMenu"
                    >
                        <ul class="top-menu-subMenu__list">
                            <template v-for="(hiddenLink, index) in hiddenLinks">
                                <li
                                    v-if="hiddenLink.isActive"
                                    :key="`${hiddenLink.slug}_${index}`"
                                    class="top-menu-subMenu__list-item"
                                    @click="toggleShowMore(false)"
                                >
                                    <n-link
                                        class="header__link"
                                        v-bind="getLinkAttr(hiddenLink.path || hiddenLink.slug)"
                                        :to="getLink(hiddenLink)"
                                    >
                                        {{ hiddenLink.title }}
                                    </n-link>
                                </li>
                            </template>
                        </ul>
                    </div>
                </transition>
            </li>
            <!-- Eco -->
            <li
                v-click-outside="() => isShowEco = false"
                class="top-menu__list-item subMenu"
            >
                <button
                    class="cibButton cibButton--empty pointer"
                    @click="isShowEco = !isShowEco"
                >
                    <nuxt-img
                        src="icons/green-vector.svg"
                        alt=""
                        format="webp"
                    />
                    <nuxt-img
                        class="cibButton__chevron"
                        :class="{
                            'opened': isShowEco
                        }"
                        src="icons/arrows/chevron-small.svg"
                        alt=""
                        format="webp"
                    />
                </button>
                <transition
                    name="fade"
                    mode="out-in"
                >
                    <div
                        v-show="isShowEco"
                        class="top-menu__subMenu top-menu__subMenu--eco top-menu-subMenu"
                    >
                        <ul class="top-menu-subMenu__list">
                            <li
                                class="top-menu-subMenu__list-item"
                                @click="isShowEco = false"
                            >
                                <n-link
                                    class="header__link"
                                    prefetch
                                    to="/esg"
                                >
                                    ESG
                                </n-link>
                            </li>
                            <li
                                class="top-menu-subMenu__list-item"
                                @click="isShowEco = false"
                            >
                                <a
                                    class="header__link"
                                    href="https://greenvector.media"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >
                                    Зелёный вектор
                                </a>
                            </li>
                        </ul>
                    </div>
                </transition>
            </li>
        </ul>
    </nav>
</template>

<script>
import {defineComponent, computed, ref} from 'vue';
import {useRoute} from '@nuxtjs/composition-api';

import {useNavigationStore} from '@/stores/navigation';

export default defineComponent({
    setup() {
        const route = useRoute();
        const navigationStore = useNavigationStore();
        const menu = computed(() => navigationStore.menu);

        const isShowMoreActive = ref(false);
        const isShowEco = ref(false);

        const isForIndividualsGroup = computed(() => {
            return route.value.path?.includes('for-individuals') ?? false;
        });

        const visibleLinks = computed(() => {
            return menu.value?.filter((item) => {
                return !item?.other;
            }) ?? [];
        });

        const hiddenLinks = computed(() => {
            return menu.value?.filter((item) => {
                return item?.other;
            }) ?? [];
        });

        function getLinkAttr(slug) {
            return {
                'active-class': slug === 'for-individuals' && !isForIndividualsGroup.value ? '' : 'header__link_active',
                'exact-active-class': 'header__link_active',
            };
        }

        function toggleShowMore(state = null) {
            if (state === null) {
                isShowMoreActive.value = !isShowMoreActive.value;
            } else {
                isShowMoreActive.value = state;
            }
        }

        function getLink(link) {
            if (link.path) {
                return link.path;
            }

            return `/${link.slug}`;
        }

        return {
            menu,
            isShowMoreActive,
            isShowEco,
            visibleLinks,
            hiddenLinks,
            getLinkAttr,
            toggleShowMore,
            getLink,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/ui-elements/cibButton';
@import '@/assets/styles/components/navigation/headerMenu';
</style>
